var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShapeDiverRequestModelTrustlevel = exports.ShapeDiverRequestModelFiletype = void 0;
var ShapeDiverRequestModelFiletype;
(function (ShapeDiverRequestModelFiletype) {
  ShapeDiverRequestModelFiletype["GRASSHOPPER_BINARY"] = "gh";
  ShapeDiverRequestModelFiletype["GRASSHOPPER_XML"] = "ghx";
})(ShapeDiverRequestModelFiletype || (exports.ShapeDiverRequestModelFiletype = ShapeDiverRequestModelFiletype = {}));
var ShapeDiverRequestModelTrustlevel;
(function (ShapeDiverRequestModelTrustlevel) {
  ShapeDiverRequestModelTrustlevel["UNDEFINED"] = "";
  ShapeDiverRequestModelTrustlevel["NONE"] = "none";
  ShapeDiverRequestModelTrustlevel["FULL"] = "full";
})(ShapeDiverRequestModelTrustlevel || (exports.ShapeDiverRequestModelTrustlevel = ShapeDiverRequestModelTrustlevel = {}));
//# sourceMappingURL=SdRequestDtoModel.js.map
export default exports;